export default __webpack_public_path__ + "static/media/img3.8bdb82ca.png";